import type { Ref } from 'vue';

import type { ResumableLoginStep } from '~/types/login';

import { LOGIN_RESUME_QUERY_KEY, loginResumeQuery, withoutLoginResume } from '~/types/login';

interface LoginResumeUrlOptions<S> {
  email: () => string;
  currentStep: Ref<S>;
  /** Whether the step is one the server holds the sign-in at, which keeps the keys in the URL. */
  isParked: (step: S) => boolean;
}

/**
 * The URL names the step a sign-in parked on the server waits at, so a reload opens it again, and
 * stops naming it once the sign-in moves to a step that is not parked.
 */
export const useLoginResumeUrl = <S>({ email, currentStep, isParked }: LoginResumeUrlOptions<S>) => {
  const route = useRoute();
  const router = useRouter();

  const parkOnUrl = (step: ResumableLoginStep) => {
    void router.replace({ path: route.path, query: { ...route.query, ...loginResumeQuery({ email: email(), step }) } });
  };

  watch(currentStep, (step) => {
    if (!isParked(step) && LOGIN_RESUME_QUERY_KEY in route.query) {
      void router.replace({ path: route.path, query: withoutLoginResume(route.query) });
    }
  });

  return { parkOnUrl };
};
